export class CrossComponentValueManager {
    valueChangeReactionFunctions: Function[];
    value?: string | number;

    constructor() {
        this.valueChangeReactionFunctions = [];
        this.value = undefined;
    }

    createValueSetter() {
        let self = this;
        return (function (value: any) {
            self.value = value;
            self.valueChangeReactionFunctions.forEach(function (valueChangeReactionFunction: Function) {
                valueChangeReactionFunction(value);
            });
        });
    };

    reactToValueChangeWith(valueChangeReactionFunction: Function) {
        if (this.valueChangeReactionFunctions.indexOf(valueChangeReactionFunction) < 0) {
            this.valueChangeReactionFunctions.push(valueChangeReactionFunction);
        }
    };
}
